import * as React from "react";
import { useState } from "react";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import { TransitionProps } from "@mui/material/transitions";
import { useHistory } from "react-router-dom";
import ChatScreen from "./ChatScreen";
import useGetParameter from "../../hooks/useGetParameter";
import { GET_PARAMS } from "../../const/router";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export type ChatModalProps = {
  chatMemberCode: number;
  memberName: string;
  memberImage: string;
  isNavigateFromProfilePage: boolean;
};

const ChatPopup = ({ isOpened }: any) => {
  const location = useLocation();
  const history = useHistory();
  const [memberImage, setMemberImage] = useState<string>("");
  const [memberName, setMemberName] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const queryProfileMemberCode = useGetParameter(GET_PARAMS.memberCode);
  const [memberCode, setMemberCode] = useState<number>(
    Number(queryProfileMemberCode)
  );

  useEffect(() => {
    console.log("ChatPopup Entering UseEffect...");

    if (isOpened) {
      const { memberImage, memberName, userName }: any = location.state;
      setMemberImage(memberImage);
      setMemberName(memberName);
      setUserName(userName);
    }
  }, []);

  return (
    <>
      <div>
        <Dialog
          className="chat_modal"
          sx={{ "& .MuiDialog-paper": { backgroundColor: "#f5f4f9" } }}
          fullScreen
          disableEscapeKeyDown={true}
          TransitionComponent={Transition}
          open={isOpened}
          onClose={history.goBack}
        >
          <div className="chat-container" style={{ overflowY: "auto" }}>
            <ChatScreen
              chatMemberCode={memberCode}
              memberName={memberName}
              memberImage={memberImage}
              userName={userName}
            />
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default ChatPopup;
